import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';

const OPERATOR_OPTIONS = [
    { value: 'EQ', imagePath: '/images/block/comparison_eq.svg', tooltip: '等しい [==]' },
    { value: 'NEQ', imagePath: '/images/block/comparison_neq.svg', tooltip: '等しくない [!=]' },
    { value: 'LT', imagePath: '/images/block/comparison_lt.svg', tooltip: '小さい [<]' },
    { value: 'LTE', imagePath: '/images/block/comparison_lte.svg', tooltip: '以下 [<=]' },
    { value: 'GT', imagePath: '/images/block/comparison_gt.svg', tooltip: '大きい [>]' },
    { value: 'GTE', imagePath: '/images/block/comparison_gte.svg', tooltip: '以上 [>=]' },
];

defineBlock({
    type: 'comparison_number',
    colour: CATEGORIES.operator.color,
    tooltip: '2つの値を比較します',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Boolean',
    inputs: [
        {
            kind: 'value',
            name: 'A',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'OP',
                    instance: () => new FieldOperatorDropdown(OPERATOR_OPTIONS),
                },
            ],
        },
        {
            kind: 'value',
            name: 'B',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
    ],
});
